import JSBI from 'jsbi';

/**
 * Функция сортировки BigInt
 * @param key — название поля, по которому сортируем
 * @param [order=asc] — порядок сортировки
 */
export function bigIntSort(key, order = 'asc') {
  return function (a, b) {
    let result = 0;
    let val_a;
    let val_b;
    if (typeof key === 'function') {
      val_a = key(a);
      val_b = key(b);
    } else {
      val_a = a[key];
      val_b = b[key];
    }
    a = JSBI.BigInt(val_a);
    b = JSBI.BigInt(val_b);
    if (JSBI.greaterThan(a, b)) {
      result = 1;
    } else if (JSBI.lessThan(a, b)) {
      result = -1;
    }
    return order === 'desc' ? result * -1 : result;
  };
}

/**
 * async/await timeout
 */
export function timeout(ms) {
  return new Promise((res) => setTimeout(res, ms));
}

/**
 * Классический debounce
 * @param f
 * @param ms
 * @returns {Function}
 */
export function debounce(f, ms) {
  let is_cooldown = false;
  return function () {
    if (is_cooldown) return;
    f.apply(this, arguments);
    is_cooldown = true;
    setTimeout(() => (is_cooldown = false), ms);
  };
}
